<template>
  <div>
    <nav aria-label="breadcrumb" style="border-radius:0;">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <router-link v-bind:to="{ 'name': $i18n.locale + 'Settings' }">
            {{ $t('settings') }}
          </router-link>
        </li>
        <li class="breadcrumb-item active" aria-current="page">{{ $t('rooms') }}</li>
      </ol>
    </nav>
    <div class="container-fluid">

      <header class="page header">
        <div class="content">
          <h1 class="display-4 mb-0 mt-4">
            {{ $t('rooms') }}
          </h1>
          <p class="lead text-muted">
          </p>
        </div>


      </header>

      <div class="content">
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <select class="form-control" v-model="property" v-bind:disabled="properties.length <= 1" @change="$router.push({'name': $i18n.locale + 'ListRooms',  params: { property: property.slug } })">
                <option v-for="(property, index) in properties" v-bind:value="property">{{property.name}}</option>
              </select>

              <table class="table table-defalt table-hover" v-if="properties.length">
                <thead>
                  <tr>
                    <th>{{ $t('name') }}</th>
                    <th>{{ $t('beds') }}</th>
                    <th>{{ $t('quantity') }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr role="button" v-for="room in rooms" @click="$router.push({ name: $i18n.locale + 'UpdateRoom', params: { room: room._id } })">
                    <td>{{ room.name }}</td>
                    <td>{{ room.maxGuests }}</td>
                    <td>{{ room.quantity }}</td>
                  </tr>
                </tbody>
              </table>
              <router-link v-bind:to="{ 'name': $i18n.locale + 'CreateRoom' }">
                {{ $t('create') }}
              </router-link>
            </div>
          </div>
        </div>

      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'Rooms',
  data: () => ({
    title: '',
    property: {
      slug: '',
      name: ''
    },
    properties: [],
    rooms: []
  }),
  created(){
    this.properties = this.$store.state.host.properties;
    let property = this.properties.find(p => p.slug == this.$route.params.property);
    this.property = property || {};

    console.log("ali smo tukaj?")
    console.log(this.property)

    if(this.property){
      this.fetchRooms();
    }
  },

  methods: {
    fetchRooms: function(){
      fetch(process.env.VUE_APP_API + '/rooms?property._id=' + this.property._id, {
        method: 'get',
        credentials: 'include',
        headers: {
          "Content-type": "application/json",
          "Accept": "application/json",
          "Accept-Charset": "utf-8",
          'CSRF-Token': this.$csrf
        }
      })
      .then(response => {
        return response.json();
      })
      .then(result => {
        console.log(result)
        if(result.error){
          console.log(result.error);
        }
        this.rooms = result;
      })
    }
  }
};
</script>


<i18n>
{
  "en": {
    "settings": "Settings",
    "properties": "Properties",
    "rooms": "Rooms",
    "name": "Name",
    "quantity": "No. of Units",
    "beds": "No. of Beds",
    "create": "Create new room type"
  },
  "sl": {
    "settings": "Nastavitve",
    "properties": "Nastanitve",
    "rooms": "Sobe",
    "name": "Naziv",
    "quantity": "Št. enot",
    "beds": "Št. ležišč",
    "create": "Ustvari nov tip sobe"
  }
}
</i18n>
